import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './constants.js';
import { setInterval } from 'timers';
import Wallet from './Wallet.js';

class App extends Component {

  constructor(props) {
    super(props);

    this.catchphrases = [
      'It Pumps Itself! You just have to dump it.',
      "We'll never put you on hodl",
      "It's a store of value",
      "Top 5 coin by March, I promise",
      "Buy XLM, my college fund is in there",
      "Buy High, Sell Low",
      "Am I the only one VeChain hasn't partnered with?",
      "The third most exciting way you'll lose money this year",
      "We use Equifax-grade security",
      "Disrupting Big Pyramid Scheme"
    ];
  }

  catchphrase() {
    return this.catchphrases[Math.floor(Math.random() * this.catchphrases.length)];
  }

  render() {
    if (typeof window.web3 === 'undefined') {

      return <div className="App" style={{margin: 'auto'}}>
        <h4 style={{margin: 40}}>PonziCoin needs an Ethereum-enabled web browser so it can store your coins! Try installing MetaMask - it'll also help you setup a secure wallet - and then refreshing the page!</h4>
        <a href="https://metamask.io/"><img style={{maxWidth: '100%'}} src="images/metamask.png"></img></a>
        </div>
    }
    return (
      <div>
         <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container">
            <p style={{margin: 'auto', color:'white'}}>This has gotten crazy out of hand, I apologize but we will no longer be selling PonziCoin on this site because this was a joke. I cannot terminate the contract but I will not be selling any coins that I own.</p>
            
            
          </div>
        </nav>
        <Wallet accounts={window.web3.eth.accounts}/>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js